/** BRL price string (e.g. "199,90") → integer cents */
export function parseBrlToCents(value: string): number {
  const trimmed = value.trim().replace(/\./g, "");
  const normalized = trimmed.replace(",", ".");
  const reais = Number.parseFloat(normalized);
  if (Number.isNaN(reais)) return NaN;
  return Math.round(reais * 100);
}

/** Integer cents → BRL form input (e.g. 19990 → "199,90") */
export function centsToBrlInput(cents: number): string {
  const fixed = (cents / 100).toFixed(2);
  return fixed.replace(".", ",");
}

/** Integer cents → formatted BRL for display in tables */
export function formatBrlCurrency(cents: number): string {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(cents / 100);
}

export const brlPriceRegex = /^\d+(?:,\d{1,2})?$/;
